module.exports = __webpack_public_path__ + "files/b67eca89250a6e89649de74b033cfaf4.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Droid-Serif-regular.eot
// module id = 368
// module chunks = 60